import { render, staticRenderFns } from "./salaryAllocation.vue?vue&type=template&id=489c0df7&scoped=true&"
import script from "./salaryAllocation.vue?vue&type=script&lang=js&"
export * from "./salaryAllocation.vue?vue&type=script&lang=js&"
import style0 from "./salaryAllocation.vue?vue&type=style&index=0&id=489c0df7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c0df7",
  null
  
)

export default component.exports